export * from './wordpress.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
